import Vue from 'vue';
import Vuex from 'vuex';

import account from './account';
import partnerUser from './partnerUser';
import customer from './customer';
import gateway from './gateway';
import device from './device';
import trigger from './trigger';
import shipping from './shipping';
import partner from './partner';

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        account,
        partnerUser,
        customer,
        gateway,
        trigger,
        device,
        shipping,
        partner
    }
});
